import React from 'react';
import { connect } from 'react-redux';
import AuthService from '../../../services/authService';
import { emptyReduxStore } from '../../../redux/actions/index';
import LoadingSpinner from '../../loaders/combinedHeaderAndSpinner';

interface RevokeProps {
    emptyReduxStore: Function;
}

const Revoke: React.FC<RevokeProps> = (props: RevokeProps): JSX.Element => {
    props.emptyReduxStore();
    AuthService.logout();

    return <LoadingSpinner />;
};

export default connect(null, { emptyReduxStore })(Revoke);
